// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pk-1";
export var stateContainer = "_pk-0";